import React from 'react';

const LogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width="80"
    height="21"
    viewBox="0 0 80 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M68.4307 16.2581L72.0104 10.7729L68.5694 5.29688H71.5202L73.9344 9.70913L76.2839 5.29688H79.2069L75.7474 10.7729L79.2902 16.2581H76.3394L73.8234 11.8366L71.3537 16.2581H68.4307Z"
      fill="currentColor"
    />
    <path
      d="M62.7989 16.3513C60.881 16.3513 59.5244 15.8549 58.7289 14.862C57.9272 13.863 57.5264 12.4971 57.5264 10.7643C57.5264 8.95744 57.9334 7.57611 58.7474 6.62027C59.5552 5.66444 60.8903 5.18652 62.7526 5.18652C64.6766 5.18652 66.0271 5.66752 66.8041 6.62952C67.5688 7.60386 67.9511 8.97594 67.9511 10.7458C67.9511 11.0356 67.9326 11.3008 67.8956 11.5413H59.7926V9.95952H65.3241C65.2624 8.84952 65.0497 8.07252 64.6859 7.62852C64.2234 7.12286 63.582 6.87002 62.7619 6.87002C61.954 6.87002 61.3004 7.14136 60.8009 7.68402C60.2952 8.22052 60.0424 9.24727 60.0424 10.7643C60.0424 12.2319 60.2921 13.2464 60.7916 13.8075C61.2788 14.381 61.9479 14.6678 62.7989 14.6678V16.3513ZM62.7989 14.6678C63.2922 14.6678 63.7115 14.5969 64.0569 14.455C64.4022 14.307 64.6735 14.0573 64.8709 13.7058C65.062 13.3543 65.2162 12.9534 65.3334 12.5033L67.6644 13.1508C67.5472 13.8846 67.2759 14.4889 66.8504 14.9638C66.4249 15.4448 65.9007 15.7963 65.2779 16.0183C64.655 16.2403 63.8287 16.3513 62.7989 16.3513V14.6678Z"
      fill="currentColor"
    />
    <path
      d="M46.2871 16.2583V5.29706H48.3036L48.8771 7.25806V16.2583H46.2871ZM53.3171 16.2583V10.2643C53.3171 9.02481 53.1506 8.17073 52.8176 7.70206C52.4908 7.22723 51.9882 6.98981 51.3099 6.98981C50.6069 6.98981 50.0118 7.26115 49.5246 7.80381C49.0374 8.34648 48.7939 9.04331 48.7939 9.89431L47.5359 9.24681C47.5359 8.30331 47.9737 7.39373 48.8494 6.51806C49.7312 5.63623 50.872 5.19531 52.2719 5.19531C53.6224 5.19531 54.5659 5.65165 55.1024 6.56431C55.645 7.47698 55.9164 8.70106 55.9164 10.2366V16.2583H53.3171Z"
      fill="currentColor"
    />
    <path
      d="M37.8921 16.2581L34.7471 5.29688H37.4666L39.8623 14.5284H39.8901L42.2581 5.29688H44.9776L41.8603 16.2581H37.8921ZM35.4038 20.5501V18.7741C36.5817 18.7741 37.4758 18.6138 38.0863 18.2931C38.703 17.9786 39.1593 17.2972 39.4553 16.2489L41.8603 16.2581C41.3608 18.0033 40.5838 19.1534 39.5293 19.7084C38.4748 20.2695 37.0997 20.5501 35.4038 20.5501Z"
      fill="currentColor"
    />
    <path
      d="M27.988 16.2586V7.08261H25.7588V5.29736H27.988V4.77936C27.988 3.63853 28.4598 2.83378 29.4033 2.36511C30.3468 1.89644 31.6603 1.66211 33.3438 1.66211H33.7045V3.38261H33.4085C32.4527 3.38261 31.7435 3.47511 31.281 3.66011C30.8185 3.84511 30.5873 4.22128 30.5873 4.78861V5.29736H33.6213V7.08261H30.5873V16.2586H27.988Z"
      fill="currentColor"
    />
    <g clipPath="url(#clip0_7721_2801)">
      <path
        d="M6.09 14.35H17.5V8.5H6.09L0 14.26V20H6.09V14.35Z"
        fill="currentColor"
      />
      <path d="M6.09 5.85H17.5V0H6.045L0 5.76V5.845" fill="currentColor" />
      <path
        d="M6.09 5.85H17.5V0H6.045L0 5.76V8.5H6.09V5.85Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_7721_2801">
        <rect width="17.5" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export default LogoIcon;
